import { Autocomplete, TextField } from '@mui/material'
import React, { useState } from 'react';



    const filterOptions = [
        { label: 'Attorney', id: 2024, value : 'attorney_name' },
        { label: 'Proprietor', id: 2023 , value : 'proprietor_name' },
        { label: 'Alert', id: 2022 , value : 'alert' },
    ]

const ManageTrademarkMisData = () => {
    const [inputValue, setInputValue] = useState(filterOptions[0]);
    const [searchValue, setSearchValue] = useState('');
    // console.log(searchValue);

  return (
    <>
    <div className="main-content">
        <div className="page-content">
            <div className="container-fluid">
                 <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">
                    Manage Trademark Data(MIS)
                  </h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="javascript: void(0);">CMS</a>
                      </li>
                      <li className="breadcrumb-item active">
                        Manage Trademark Data(MIS)
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

              <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-body">
                           <form>
                              <div className='row'>
                                <div className="col-lg-3">
                                    <Autocomplete
                                        disablePortal   
                                        id="combo-box-demo"
                                        options={filterOptions}
                                        sx={{ width: 300 }}
                                        value={inputValue}
                                         onChange={(event, newValue) => {
                                            setInputValue(newValue);
                                            }}
                                        renderInput={(params) => <TextField {...params} label="Select Filter Type" />}
                                    />
                                </div>
                                  <div className="col-lg-3">
                                   <TextField
                                        fullWidth
                                        label="Search"
                                        id="fullWidth"
                                        variant='outlined'
                                        value={searchValue}
                                        onChange={(e) => setSearchValue(e.target.value)}
                                        placeholder='Enter Exact Search Value'
                                    />
                                </div>
                              </div>
                           </form>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-body">
                             <h4 className="card-title mb-4">
                            Total
                           </h4>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default ManageTrademarkMisData;